// extracted by mini-css-extract-plugin
export default {"compContainer":"calcScore_compContainer__Vh1vP","minus":"calcScore_minus__PZMT3","add":"calcScore_add__v+vES","operator":"calcScore_operator__RVrQh"};